'use client';

import { c as _c } from "react/compiler-runtime";
import { FC, HTMLAttributes, useRef } from 'react';
import InlineTags from '@/components/BlogPage/InlineTags';
import { BlogPostDto } from '@/components/BlogPage/types';
import Image from '@/components/Image';
import Link from '@/components/Link';
import { Typography } from '@/components/shared/Typography';
import VimeoPlayer from '@/components/shared/VimeoPlayer';
import StrapiRichContent from '@/components/StrapiRichContent';
import cn from '@/helpers/cn';
import { useBlogPost } from '@/hooks/blog/useBlogPost';
import { useVimeoViewportPlayback } from '@/hooks/useVimeoViewportPlayback';
import css from './style.module.scss';
interface Props extends Omit<HTMLAttributes<HTMLAnchorElement>, 'title'> {
  post: BlogPostDto;
}
const TableRow: FC<Props> = t0 => {
  const $ = _c(29);
  let post;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      post,
      className: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = post;
    $[2] = rest;
    $[3] = t1;
  } else {
    post = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const className = t1 === undefined ? "" : t1;
  const {
    cardTitle,
    media,
    isVideo,
    href
  } = useBlogPost(post);
  const rowRef = useRef(null);
  const rowVimeoPlaying = useVimeoViewportPlayback(rowRef);
  let t2;
  if ($[4] !== className) {
    t2 = cn(css.postRow, className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== post.tags) {
    t3 = <Typography variant="body-s" responsive={false}><InlineTags tags={post.tags} /></Typography>;
    $[6] = post.tags;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isVideo || $[9] !== media || $[10] !== rowVimeoPlaying) {
    t4 = isVideo && media ? <div className={css.mediaWrapper}><VimeoPlayer className={css.media} url={media.url} playing={rowVimeoPlaying} /></div> : media && "width" in media && <div className={css.mediaWrapper}><Image className={css.media} src={media.url} width={media.width} height={media.height} alt={media.alternativeText || ""} quality={100} /></div>;
    $[8] = isVideo;
    $[9] = media;
    $[10] = rowVimeoPlaying;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== cardTitle) {
    t5 = <Typography className={css.title} variant="h5" tag="h2"><StrapiRichContent content={cardTitle} /></Typography>;
    $[12] = cardTitle;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== post.preview) {
    t6 = post.preview?.description ? <Typography variant="body-m"><StrapiRichContent content={post.preview.description} /></Typography> : null;
    $[14] = post.preview;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <div>{t5}{t6}</div>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== post.timeToRead) {
    t8 = post.timeToRead ? <Typography className={css.timeToRead} variant="body-l" tag="p"><span>{post.timeToRead}</span><img src="/assets/icons/arrow-link.svg" width={12} height={12} alt="" /></Typography> : null;
    $[19] = post.timeToRead;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== href || $[22] !== rest || $[23] !== t2 || $[24] !== t3 || $[25] !== t4 || $[26] !== t7 || $[27] !== t8) {
    t9 = <Link ref={rowRef} className={t2} href={href} {...rest}>{t3}{t4}{t7}{t8}</Link>;
    $[21] = href;
    $[22] = rest;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
};
export default TableRow;